<template>
    <div class="container">
        <div class="pt-5">
            <h1 class="h3">Settings</h1>
            <div class="py-2">

                <settings-menu></settings-menu>
            </div>
            <div class="row py-3 border-bottom" v-if="companyDetails.companysettings">
                <div class="col-12">
                    <div id="customizationAccordion" class="accordion">

                        <div class="card">
                            <div class="card-header d-flex justify-content-between align-items-center flex-wrap">
                                <button class="btn btn-link p-0 accordion-toggle" type="button" data-toggle="collapse" data-target="#collapseDocCustomization">
                                    <i class="bi bi-chevron-down mr-2"></i>Invoice &amp; Quote Customization
                                </button>
                                <button class="btn btn-primary px-3" @click="saveCompanyDetails">Save Changes</button>
                            </div>
                            <div id="collapseDocCustomization" class="collapse show">
                                <div class="card-body">
                                    <p class="text-muted mb-3">Controls how your Quote and Invoice documents look — branding, numbering, and default text merchants don't want to retype every time. Changes update the mockup on the right as you type.</p>

                                    <div class="row">
                                    <div class="col-lg-7">
                                    <div class="row mb-3">
                                        <div class="col-md-4">
                                            <label class="mb-1">Accent color</label>
                                            <div class="d-flex" style="gap:8px;">
                                                <input type="color" class="form-control p-1" style="max-width:56px;" v-model="companyDetails.companysettings.document_accent_color">
                                                <input type="text" class="form-control" placeholder="#2c3e50" v-model="companyDetails.companysettings.document_accent_color">
                                            </div>
                                            <small class="text-muted">Used for headings and table headers on Quote/Invoice PDFs.</small>
                                        </div>
                                        <div class="col-md-4">
                                            <label class="mb-1 d-block">Logo on documents</label>
                                            <div class="custom-control custom-switch">
                                                <input type="checkbox" class="custom-control-input" id="documentShowLogo" v-model="companyDetails.companysettings.document_show_logo">
                                                <label class="custom-control-label" for="documentShowLogo">Show company logo on Quotes &amp; Invoices</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row mb-3">
                                        <div class="col-md-6 form-group">
                                            <label class="mb-1">Tagline</label>
                                            <input type="text" class="form-control" maxlength="120" placeholder="e.g. Animal Feeds" v-model="companyDetails.companysettings.document_tagline">
                                            <small class="text-muted">Shown under your business name.</small>
                                        </div>
                                        <div class="col-md-6 form-group">
                                            <label class="mb-1">Description</label>
                                            <input type="text" class="form-control" maxlength="255" placeholder="e.g. Dealers in poultry, dairy and pig feeds" v-model="companyDetails.companysettings.document_description">
                                            <small class="text-muted">A smaller line under the tagline.</small>
                                        </div>
                                        <div class="col-12"><small class="text-muted">Both appear at the top of receipts, invoices, quotes, delivery notes, requisitions, GRNs and statements. Leave blank to hide.</small></div>
                                    </div>

                                    <div id="documentSettingsAccordion" class="accordion">
                                        <div class="card">
                                            <div class="card-header">
                                                <button class="btn btn-link accordion-toggle-sub" type="button" data-toggle="collapse" data-target="#collapseQuoteSettings">
                                                    <i class="bi bi-file-earmark-text mr-1"></i> Quotes
                                                </button>
                                            </div>
                                            <div id="collapseQuoteSettings" class="collapse show" data-parent="#documentSettingsAccordion">
                                                <div class="card-body">
                                                    <div class="row">
                                                        <div class="col-md-6 form-group">
                                                            <label>Quote number prefix</label>
                                                            <input type="text" class="form-control" placeholder="QT-" v-model="companyDetails.companysettings.quote_prefix">
                                                        </div>
                                                        <div class="col-md-6 form-group">
                                                            <label>Default validity (days)</label>
                                                            <input type="number" min="1" class="form-control" placeholder="14" v-model.number="companyDetails.companysettings.quote_validity_days">
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-md-6 form-group">
                                                            <label>Starting quote number</label>
                                                            <input type="number" min="1" class="form-control" placeholder="e.g. 501" v-model.number="companyDetails.companysettings.quote_starting_number">
                                                            <small class="text-muted d-block" v-if="lastQuoteNumber">Highest quote number issued so far: <strong>{{ lastQuoteNumber }}</strong>. This setting only raises the next number — it won't go below one you've already issued.</small>
                                                            <small class="text-muted">Migrating from another platform? The next quote you create will pick up from this number, so your sequence continues instead of restarting at 1. Leave blank to keep numbering from 1. Numbers already issued in Dukakit are never skipped or reused.</small>
                                                        </div>
                                                    </div>
                                                    <div class="form-group">
                                                        <label>Default notes <small class="text-muted">(pre-fills every new quote — editable per document)</small></label>
                                                        <textarea class="form-control" rows="2" v-model="companyDetails.companysettings.quote_default_notes"></textarea>
                                                    </div>
                                                    <div class="form-group mb-0">
                                                        <label>Default terms</label>
                                                        <textarea class="form-control" rows="2" placeholder="e.g. Prices valid for 14 days from issue date." v-model="companyDetails.companysettings.quote_default_terms"></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card">
                                            <div class="card-header">
                                                <button class="btn btn-link collapsed accordion-toggle-sub" type="button" data-toggle="collapse" data-target="#collapseInvoiceSettings">
                                                    <i class="bi bi-receipt mr-1"></i> Invoices
                                                </button>
                                            </div>
                                            <div id="collapseInvoiceSettings" class="collapse" data-parent="#documentSettingsAccordion">
                                                <div class="card-body">
                                                    <div class="row">
                                                        <div class="col-md-6 form-group">
                                                            <label>Invoice number prefix</label>
                                                            <input type="text" class="form-control" placeholder="INV-" v-model="companyDetails.companysettings.invoice_prefix">
                                                        </div>
                                                        <div class="col-md-6 form-group">
                                                            <label>Default payment due (days)</label>
                                                            <input type="number" min="1" class="form-control" placeholder="14" v-model.number="companyDetails.companysettings.invoice_due_days">
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-md-6 form-group">
                                                            <label>Starting invoice number</label>
                                                            <input type="number" min="1" class="form-control" placeholder="e.g. 501" v-model.number="companyDetails.companysettings.invoice_starting_number">
                                                            <small class="text-muted d-block" v-if="lastInvoiceNumber">Highest invoice number issued so far: <strong>{{ lastInvoiceNumber }}</strong>. This setting only raises the next number — it won't go below one you've already issued.</small>
                                                            <small class="text-muted">Migrating from another platform? The next invoice you create will pick up from this number, so your sequence continues instead of restarting at 1. Leave blank to keep numbering from 1. Numbers already issued in Dukakit are never skipped or reused.</small>
                                                        </div>
                                                    </div>
                                                    <div class="form-group">
                                                        <label>Default notes <small class="text-muted">(pre-fills every new invoice — editable per document)</small></label>
                                                        <textarea class="form-control" rows="2" v-model="companyDetails.companysettings.invoice_default_notes"></textarea>
                                                    </div>
                                                    <div class="form-group mb-0">
                                                        <label>Default terms</label>
                                                        <textarea class="form-control" rows="2" placeholder="e.g. Payment due within 14 days. Late payments may incur a fee." v-model="companyDetails.companysettings.invoice_default_terms"></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </div>

                                    <div class="col-lg-5">
                                        <div class="doc-mockup" :style="{ borderColor: accentColor }">
                                            <div class="d-flex justify-content-center mb-2" style="gap:6px;">
                                                <button type="button" class="btn btn-sm" :class="docPreview === 'quote' ? 'btn-primary' : 'btn-outline-secondary'" @click="docPreview = 'quote'">Quote</button>
                                                <button type="button" class="btn btn-sm" :class="docPreview === 'invoice' ? 'btn-primary' : 'btn-outline-secondary'" @click="docPreview = 'invoice'">Invoice</button>
                                            </div>
                                            <div class="doc-mockup-header" :style="{ backgroundColor: accentColor }">
                                                <img v-if="showLogo && companyDetails.logo_url" :src="companyDetails.logo_url" class="doc-mockup-logo" alt="Logo">
                                                <div class="doc-mockup-title">{{ docPreview === 'quote' ? 'QUOTE' : 'INVOICE' }}</div>
                                            </div>
                                            <div class="doc-mockup-body">
                                                <div class="font-weight-bold">{{ companyDetails.name }}</div>
                                                <div class="d-flex justify-content-between text-muted small mb-2">
                                                    <span>{{ docPrefix }}000001</span>
                                                    <span>{{ docDate }}</span>
                                                </div>
                                                <table class="doc-mockup-table">
                                                    <thead :style="{ backgroundColor: accentColor, color: '#fff' }">
                                                        <tr><th>Description</th><th>Qty</th><th>Price</th><th>Total</th></tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr><td>Sample product</td><td>2</td><td>1,500.00</td><td>3,000.00</td></tr>
                                                    </tbody>
                                                </table>
                                                <div class="text-right font-weight-bold mt-1">Total: {{ companyDetails.companysettings.currency }} 3,000.00</div>
                                                <div class="small mt-2" v-if="docNotes"><strong>Notes:</strong> {{ docNotes }}</div>
                                                <div class="small mt-1 text-muted" v-if="docTerms"><strong>Terms:</strong> {{ docTerms }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header d-flex justify-content-between align-items-center flex-wrap">
                                <button class="btn btn-link collapsed p-0 accordion-toggle" type="button" data-toggle="collapse" data-target="#collapseReceiptPreview">
                                    <i class="bi bi-chevron-down mr-2"></i>Receipt Settings
                                </button>
                                <button class="btn btn-primary px-3" @click="saveCompanyDetails">Save Changes</button>
                            </div>
                            <div id="collapseReceiptPreview" class="collapse">
                                <div class="card-body">
                                    <p class="text-muted mb-3">Controls your POS receipt's numbering, print policy and branding. Changes update the mockup on the right as you type.</p>

                                    <div class="row">
                                        <div class="col-lg-6">
                                            <div class="row mb-3">
                                                <div class="col-md-6 form-group">
                                                    <label>Receipt number prefix</label>
                                                    <input type="text" class="form-control" placeholder="SALE-" v-model="companyDetails.companysettings.receipt_prefix">
                                                    <small class="text-muted">e.g. DUKA — receipt numbers read DUKA-000001.</small>
                                                </div>
                                                <div class="col-md-6 form-group">
                                                    <label>Starting number</label>
                                                    <input type="number" min="1" class="form-control" v-model.number="companyDetails.companysettings.receipt_no_suffix">
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label>Print limit</label>
                                                <input type="number" min="1" class="form-control" placeholder="Unlimited" v-model.number="companyDetails.companysettings.receipt_print_limit">
                                                <small class="text-muted">Max times a receipt can be printed per order. Leave blank for unlimited. Admins and users with <em>can manage orders</em> permission can always override.</small>
                                            </div>
                                            <div class="form-group">
                                                <label>Footer message</label>
                                                <textarea class="form-control" rows="2" placeholder="e.g. Thank you for shopping with us!" v-model="companyDetails.companysettings.receipt_footer_message"></textarea>
                                                <small class="text-muted">Printed at the bottom of every receipt.</small>
                                            </div>
                                            <div class="form-group mb-0">
                                                <label>Extra details</label>
                                                <textarea class="form-control" rows="2" placeholder="Terms, payment info, etc." v-model="companyDetails.configs"></textarea>
                                                <small class="text-muted">Printed just above the footer message.</small>
                                            </div>
                                        </div>
                                        <div class="col-lg-6">
                                    <div class="container text-left mb-3">
                                        <div id="print_invoice">
                                            <div class="ticket-container">
                                                <div class="ticket">
                                                    <div v-if="companyDetails !=='' && showLogo" class="text-center">
                                                        <img v-if="companyDetails.logo_url !==null"  class="centered" :src="companyDetails.logo_url" style="width: auto; height: auto; max-height:120px" alt="Logo">
                                                        <p v-else  class="centered" >Logo</p>

                                                    </div>
                                                    <p class="centered text-center" v-if="companyDetails !==''">
                                                        <span class="compan-details">{{companyDetails.name}}</span>
                                                        <span v-if="companyDetails.companysettings.document_tagline"><br><strong><em>{{companyDetails.companysettings.document_tagline}}</em></strong></span>
                                                        <span v-if="companyDetails.companysettings.document_description"><br><small>{{companyDetails.companysettings.document_description}}</small></span>
                                                        <span v-if="companyDetails.phone !==null"><br>Phone:{{companyDetails.phone}}</span>
                                                        <span v-if="companyDetails.email !==null"> <br>Email:{{companyDetails.email}}</span>
                                                        <span v-if="companyDetails.address !==null"><br>Address:{{companyDetails.address}}</span>
                                                        <span v-if="companyDetails.building !==null"><br>Location:{{companyDetails.building}}</span><span v-if="companyDetails.street !==''">{{companyDetails.street}}</span>
                                                        <span v-if="companyDetails.town !==null"><br>Town:{{companyDetails.town}}</span>
                                                        <span v-if="companyDetails.krapin !==null"><br>PIN:{{companyDetails.krapin}}</span>
                                                    </p>
                                                    <p class="text-center">Order Number: {{ sampleOrderNumber }}</p>
                                                    <table class="table table-bordered">
                                                        <thead :style="{ backgroundColor: accentColor, color: '#fff' }">
                                                        <tr>
                                                            <th class="quantity">QTY</th>
                                                            <th class="description">Description</th>
                                                            <th class="price">{{companyDetails.companysettings.currency}}</th>
                                                            <th >Totals</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                      <tr>
                                                        <td>1</td>
                                                            <td>Item 1</td>
                                                            <td>100</td>
                                                            <td>100</td>

                                                      </tr>
                                                      <tr>
                                                        <td>2</td>
                                                            <td>Item 2</td>
                                                            <td>200</td>
                                                            <td>400</td>

                                                      </tr>
                                                      <tr>
                                                        <td>3</td>
                                                            <td>Item 3</td>
                                                            <td>300</td>
                                                            <td>900</td>

                                                      </tr>
                                                     <tr>
                                                        <td class="totals"><b>Sub-Total</b></td>
                                                            <td class="totals"></td>
                                                            <td class="totals"></td>
                                                            <td class="totals" v-if="companyDetails.companysettings.enable_taxes"><b >{{companyDetails.companysettings.currency}} 1206.90</b></td>
                                                            <td class="totals" v-else><b >{{companyDetails.companysettings.currency}} 1400</b></td>
                                                     </tr>

                                                        <tr v-if="companyDetails.companysettings.enable_discounts">
                                                            <td class="totals"><b>Discounts</b></td>
                                                            <td class="totals"></td>
                                                            <td class="totals"></td>
                                                            <td class="totals"><b >{{companyDetails.companysettings.currency}} 0</b></td>
                                                     </tr>
                                                     <tr v-if="companyDetails.companysettings.enable_taxes">

                                                        <td class="totals"><b>VAT</b></td>
                                                            <td class="totals"></td>
                                                            <td class="totals"></td>
                                                            <td class="totals"><b >{{companyDetails.companysettings.currency}} 193.10</b></td>
                                                     </tr>
                                                     <tr>
                                                        <td class="totals"><b>Total</b></td>
                                                            <td class="totals"></td>
                                                            <td class="totals"></td>
                                                            <td class="totals"><b >{{companyDetails.companysettings.currency}} 1400</b></td>
                                                     </tr>

                                                        </tbody>
                                                    </table>


                                                    <p class="text-center">You were served by:
                                                        <span class="text-capitalize">{{userDetails.full_name ?? userDetails.name}}</span>
                                                        </p>
                                                        <p class="text-center" v-if="companyDetails !==''" v-html="companyDetails.configs"></p>

                                                        <p class="text-center" v-if="companyDetails.companysettings.receipt_footer_message !==null">{{ companyDetails.companysettings.receipt_footer_message }}</p>
                                                </div>
                                            </div>
                                            <div class="container text-center">
                                                <button type="button" class="btn btn-primary print-action" @click="printReceipt">Print Receipt</button>
                                            </div>
                                        </div>
                                    </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "profile",
        data() {
            return {
                companyDetails:{
                    companysettings:{}
                },
                userDetails:{},
                lastQuoteNumber: null,
                lastInvoiceNumber: null,
                docPreview: 'quote',
            }
        },
        computed: {
            showLogo() {
                const settings = this.companyDetails.companysettings;
                return !settings || settings.document_show_logo !== false;
            },
            accentColor() {
                const settings = this.companyDetails.companysettings;
                return (settings && settings.document_accent_color) || '#55595f';
            },
            sampleOrderNumber() {
                const settings = this.companyDetails.companysettings;
                const prefix = (settings && settings.receipt_prefix) || 'SALE-';
                const start = (settings && settings.receipt_no_suffix) || 1;
                return prefix + String(start).padStart(2, '0');
            },
            docPrefix() {
                const settings = this.companyDetails.companysettings;
                if (this.docPreview === 'quote') return (settings && settings.quote_prefix) || 'QT-';
                return (settings && settings.invoice_prefix) || 'INV-';
            },
            docNotes() {
                const settings = this.companyDetails.companysettings;
                return this.docPreview === 'quote' ? settings.quote_default_notes : settings.invoice_default_notes;
            },
            docTerms() {
                const settings = this.companyDetails.companysettings;
                return this.docPreview === 'quote' ? settings.quote_default_terms : settings.invoice_default_terms;
            },
            docDate() {
                return moment().format('DD MMM YYYY');
            },
        },
        mounted() {
            this.getUserCompanyDetails()
            this.getLastDocumentNumbers()
        },
        methods: {
            getLastDocumentNumbers() {
                axios.get('/api/quotes/stats')
                    .then(result => { this.lastQuoteNumber = result.data.last_number })
                    .catch(() => {});
                axios.get('/api/invoices/stats')
                    .then(result => { this.lastInvoiceNumber = result.data.last_number })
                    .catch(() => {});
            },
            changeCompanyLogo(e) {
                e.preventDefault();
                let imagefilename = document.getElementById('filename').value;
                axios.post('/api/update-company-logo', {
                        companyId: this.companyDetails.id,
                        companyLogo: imagefilename
                    })
                    .then(result => {
                        this.$refs['editprofile'].hide()
                        this.$toasts.push({
                            type: 'success',
                            message: result.data.message
                        })
                    }).catch(errors => {
                        console.log(errors.message)
                    });
            },
            getUserCompanyDetails() {
                axios.get('/api/user')
                    .then(result => {
                        this.companyDetails = result.data.company
                        this.userDetails = result.data
                    }).catch(errors => {
                        console.log(errors.message)
                    });
            },
            saveCompanyDetails() {
                axios.post('/api/update-company', { ...this.companyDetails
                }).then(results => {
                    this.$toasts.push({
                        type: 'success',
                        message: "Company details have updated"
                    })
                }).catch(errors => {
                })
            },
            splitReceiptConfig(string){
                return string
            },
            printReceipt() {
                this.$htmlToPaper('print_invoice');
            },
        },
    }
</script>

<style scoped>
.ticket-container {
    max-width: 100%;
    width: 100%;
}
.ticket {
    width: 100%;
}
.ticket .table td, .ticket .table th {
    padding: 1px !important;
}
.accordion-toggle {
    font-size: 1.05rem;
    font-weight: 600;
    color: #fd4719;
    text-decoration: none;
}
.accordion-toggle:hover, .accordion-toggle:focus {
    color: #fd4719;
    text-decoration: none;
}
.accordion-toggle-sub {
    color: #fd4719;
    text-decoration: none;
}
.accordion-toggle-sub:hover, .accordion-toggle-sub:focus {
    color: #fd4719;
    text-decoration: none;
}
.doc-mockup {
    border: 1px solid #dee2e6;
    border-radius: 6px;
    overflow: hidden;
    background: #fff;
    position: sticky;
    top: 1rem;
}
.doc-mockup-header {
    padding: 14px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #fff;
}
.doc-mockup-logo {
    max-height: 32px;
    max-width: 100px;
    width: auto;
    height: auto;
    object-fit: contain;
    background: #fff;
    border-radius: 3px;
    padding: 2px 4px;
}
.doc-mockup-title {
    font-weight: 700;
    letter-spacing: 1px;
    font-size: 0.95rem;
}
.doc-mockup-body {
    padding: 14px 16px;
    font-size: 0.85rem;
}
.doc-mockup-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 0.8rem;
}
.doc-mockup-table th, .doc-mockup-table td {
    padding: 4px 6px;
    text-align: left;
}
.doc-mockup-table td:nth-child(2), .doc-mockup-table th:nth-child(2),
.doc-mockup-table td:nth-child(3), .doc-mockup-table th:nth-child(3),
.doc-mockup-table td:nth-child(4), .doc-mockup-table th:nth-child(4) {
    text-align: right;
}
.doc-mockup-table tbody tr {
    border-bottom: 1px solid #eee;
}
</style>
